import type { vendorApiNames } from '../names';
import type { ApiTokenAuthentication } from './auth';
import type {
  ApiVersion,
  BaseUpdateVendorApiSettings,
  BaseUrl,
  BaseVendorApi,
  PaginationSettings,
  RejectUnauthorized,
} from './base';
import type {
  VendorApiHttpAdvancedSettings,
  VendorApiHttpAgentSettings,
} from './http';

/**
 * Juniper Mist API settings available from API
 */
export type PublicJuniperMistApiSettings = BaseVendorApi<
  (typeof vendorApiNames)['junipermist']
> &
  RejectUnauthorized &
  BaseUrl &
  VendorApiHttpAgentSettings &
  VendorApiHttpAdvancedSettings &
  PaginationSettings &
  Required<ApiVersion<'v1'>>;

/**
 * Juniper Mist API settings available in backend
 */
export type JuniperMistApiSettings = PublicJuniperMistApiSettings &
  ApiTokenAuthentication;

/**
 * Juniper Mist API settings expected on API when updating
 */
export type UpdateJuniperMistApiSettings = BaseUpdateVendorApiSettings<
  PublicJuniperMistApiSettings,
  ApiTokenAuthentication
>;
